import { DecisionModel, DMNResolutionContext, OutputEntries } from './types'
import { resolveData } from './resolveData'
import { evaluateDecisionTable } from './evaluateDecisionTable'

// TODO: support multiple decision tables per model
export function evaluateDecisionModel(
  model: DecisionModel,
  context: DMNResolutionContext
): OutputEntries | OutputEntries[] {
  const table = model.decision_tables[0]
  if (!table) return []

  const resolvedData = resolveData(model.data, context)

  return evaluateDecisionTable(table, resolvedData)
}
